module.exports = __webpack_public_path__ + "media/images/flags/sy-6d7188f85dd84d39154ff4844d601ac0.svg";